export const SIDEBARSHOW = '@sidebarshow';
export const ANUNCIO_DATA = '@anuncio_data';
